/**
 * Theme Requirements Aggregation for Apartment Management Consultants
 * 
 * Extends the base landing-page theme requirements with Apartment Management Consultants specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-landing-page/requirements';

/**
 * Apartment Management Consultants component requirement overrides.
 * Add requirements for any override components here.
 */
const apartmentmanagementconsultantsOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Apartment Management Consultants theme.
 * Inherits from landing-page theme and overrides with Apartment Management Consultants components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...apartmentmanagementconsultantsOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
